import baseAPI from '@/api/base';
import { EditAttendanceShift, GetAttendanceShift, RegisterAttendanceShift } from '@/dtos/attendance_shift.dto';
import {
  DELETE_ATTENDANCE_SHIFT_URL,
  EDIT_ATTENDANCE_SHIFT_URL,
  GET_ATTENDANCE_SHIFT_URL,
  REGISTER_ATTENDANCE_SHIFT_URL,
  TOGGLE_ATTENDANCE_SHIFT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class AttendanceShift {
  static getAttendanceShifts = async (getAttendanceShift: GetAttendanceShift): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ATTENDANCE_SHIFT_URL, {
      params: getAttendanceShift,
    });
    console.log('response', response);
    return response;
  };

  static registerAttendanceShift = async (
    registerAttendanceShift: RegisterAttendanceShift
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_ATTENDANCE_SHIFT_URL, {
      ...registerAttendanceShift,
    });
    console.log('response', response);
    return response;
  };

  static editAttendanceShift = async (editAttendanceShift: EditAttendanceShift): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_ATTENDANCE_SHIFT_URL, {
      ...editAttendanceShift,
    });
    return response;
  };

  static toggleAttendanceShiftIsActive = async (
    editAttendanceShift: EditAttendanceShift
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ATTENDANCE_SHIFT_IS_ACTIVE_URL,
      {
        ...editAttendanceShift,
      }
    );
    return response;
  };

  static deleteAttendanceShift = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ATTENDANCE_SHIFT_URL}/${userId}`
    );
    return response;
  };
}

export default AttendanceShift;
